/* ============================================================
   pp-quickview.js — EPOMAKER 3.0 recommended-product quick view.
   Delegated opener for [data-qv-open] (value = product URL). Lazily
   builds a modal shell, fetches sections/pp-quickview via the Section
   Rendering API (?section_id=pp-quickview), injects it, and wires the
   3.0 buy card (variant picker, gallery, qty, Shop Pay, Add to Cart).
   ============================================================ */
(function () {
  if (window.__ppQuickviewInit) return;
  window.__ppQuickviewInit = true;

  var MODAL_CSS = '\
.qv-modal{position:fixed;inset:0;z-index:9998;display:flex;align-items:center;justify-content:center;padding:clamp(12px,3vw,40px);}\
.qv-modal[hidden]{display:none;}\
.qv-modal__backdrop{position:absolute;inset:0;background:rgba(3,6,10,0.72);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);opacity:0;transition:opacity 240ms ease;}\
.qv-modal.is-open .qv-modal__backdrop{opacity:1;}\
.qv-modal__dialog{position:relative;width:min(1180px,94vw);max-height:92vh;overflow-y:auto;overflow-x:hidden;background:radial-gradient(90% 120% at 82% -10%,#0b4468 0%,rgba(6,11,16,0) 55%),#060B10;border-radius:20px;box-shadow:0 40px 120px rgba(0,0,0,0.6);opacity:0;transform:translateY(16px) scale(0.99);transition:opacity 240ms ease,transform 320ms cubic-bezier(0.23,1,0.32,1);-webkit-overflow-scrolling:touch;}\
.qv-modal.is-open .qv-modal__dialog{opacity:1;transform:none;}\
.qv-modal__close{position:absolute;top:16px;right:16px;z-index:6;width:50px;height:50px;padding:0;border:1px solid rgba(255,255,255,0.3);border-radius:50%;background:rgba(255,255,255,0.12);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);color:#fff;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;transition:transform 160ms cubic-bezier(0.23,1,0.32,1),background 200ms cubic-bezier(0.23,1,0.32,1);}\
.qv-modal__close svg{width:24px;height:24px;}\
.qv-modal__close:active{transform:scale(0.94);}\
@media (hover:hover) and (pointer:fine){.qv-modal__close:hover{background:rgba(255,255,255,0.24);}}\
.qv-modal__spinner{position:absolute;top:50%;left:50%;width:40px;height:40px;margin:-20px 0 0 -20px;border-radius:50%;border:3px solid rgba(0,0,0,0.15);border-top-color:#0099FF;animation:qvspin 0.7s linear infinite;}\
@keyframes qvspin{to{transform:rotate(360deg);}}\
.qv-modal.is-loading .qv-modal__content{visibility:hidden;}\
@media (prefers-reduced-motion:reduce){.qv-modal__backdrop,.qv-modal__dialog,.qv-modal__close{transition:none;}.qv-modal__spinner{animation:none;}}';

  var modal, dialog, contentEl, spinnerEl, lastFocus, loadToken = 0, activeFlkty = null;

  function injectStyle() {
    if (document.getElementById('qv-modal-style')) return;
    var st = document.createElement('style');
    st.id = 'qv-modal-style';
    st.textContent = MODAL_CSS;
    document.head.appendChild(st);
  }

  function buildModal() {
    injectStyle();
    modal = document.createElement('div');
    modal.className = 'qv-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.hidden = true;
    modal.innerHTML =
      '<div class="qv-modal__backdrop" data-qv-close></div>' +
      '<div class="qv-modal__dialog" role="document">' +
        '<button type="button" class="qv-modal__close" data-qv-close aria-label="Close">' +
          '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<div class="qv-modal__spinner" aria-hidden="true"></div>' +
        '<div class="qv-modal__content" data-qv-content></div>' +
      '</div>';
    document.body.appendChild(modal);
    dialog = modal.querySelector('.qv-modal__dialog');
    contentEl = modal.querySelector('[data-qv-content]');
    spinnerEl = modal.querySelector('.qv-modal__spinner');

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-qv-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) close();
    });
  }

  function open(url) {
    if (!modal) buildModal();
    lastFocus = document.activeElement;
    modal.hidden = false;
    modal.classList.add('is-loading');
    spinnerEl.style.display = '';
    contentEl.innerHTML = '';
    document.documentElement.style.overflow = 'hidden';
    // trigger transition
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    var closeBtn = modal.querySelector('.qv-modal__close');
    if (closeBtn) closeBtn.focus();

    var token = ++loadToken;
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + sep + 'section_id=pp-quickview', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (token !== loadToken || modal.hidden) return;
        contentEl.innerHTML = html;
        modal.classList.remove('is-loading');
        spinnerEl.style.display = 'none';
        dialog.scrollTop = 0;
        var root = contentEl.querySelector('[data-qv-root]');
        if (root) initQV(root);
      })
      .catch(function () {
        if (token !== loadToken) return;
        modal.classList.remove('is-loading');
        spinnerEl.style.display = 'none';
        // On failure, fall back to the real product page.
        window.location.href = url;
      });
  }

  function close() {
    if (!modal || modal.hidden) return;
    loadToken++;
    if (activeFlkty) { try { activeFlkty.destroy(); } catch (e) {} activeFlkty = null; }
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var done = function () {
      modal.hidden = true;
      contentEl.innerHTML = '';
      modal.removeEventListener('transitionend', onEnd);
    };
    var onEnd = function (e) { if (e.target === dialog) done(); };
    modal.addEventListener('transitionend', onEnd);
    setTimeout(done, 400); // fallback if transitionend doesn't fire
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  /* ── Wire the injected buy card ── */
  function initQV(root) {
    var data = {};
    var dataEl = root.querySelector('[data-qv-data]');
    if (dataEl) { try { data = JSON.parse(dataEl.textContent) || {}; } catch (e) {} }
    var variants = data.variants || [];
    var moneyFormat = data.moneyFormat || '${{amount}}';
    var ATC_LABEL = data.atcLabel || 'Add to Cart';

    var form = root.querySelector('#qv-form') || root.querySelector('.qv__form');
    var inputs = [].slice.call(root.querySelectorAll('[data-qv-opt]'));
    var vid = root.querySelector('[data-qv-vid]');
    var priceEl = root.querySelector('[data-qv-price]');
    var compareEl = root.querySelector('[data-qv-compare]');
    var atc = root.querySelector('[data-qv-atc]');
    var atcLabel = root.querySelector('[data-qv-atc-label]');
    var thumbs = [].slice.call(root.querySelectorAll('[data-qv-thumb]'));
    var optValues = [].slice.call(root.querySelectorAll('[data-qv-opt-value]'));

    // Gallery — Flickity slider + synced thumbnails (mirrors the hero).
    var galleryEl = root.querySelector('[data-qv-gallery]');
    var flkty = null;
    function setActiveThumbIdx(idx) { thumbs.forEach(function (t) { t.classList.toggle('is-active', +t.getAttribute('data-cell-index') === idx); }); }
    function selectMedia(mediaId) {
      if (!flkty || !mediaId) return;
      var t = root.querySelector('[data-qv-thumb][data-media-id="' + mediaId + '"]');
      if (t) flkty.select(+t.getAttribute('data-cell-index'));
    }
    if (galleryEl && window.Flickity && galleryEl.querySelectorAll('.qv__cell').length > 1) {
      flkty = new Flickity(galleryEl, { cellAlign: 'center', contain: true, pageDots: false, prevNextButtons: false, wrapAround: true, draggable: true, imagesLoaded: true });
      activeFlkty = flkty;
      thumbs.forEach(function (t) { t.addEventListener('click', function () { flkty.select(+t.getAttribute('data-cell-index')); }); });
      flkty.on('change', setActiveThumbIdx);
      setTimeout(function () { if (flkty) flkty.resize(); }, 60);
    }

    function money(cents) {
      if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents, moneyFormat);
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }
    function currentOptions() {
      var opts = [];
      root.querySelectorAll('.qv__opt').forEach(function (fs) {
        var pos = parseInt(fs.getAttribute('data-option-position'), 10) || 1;
        var checked = fs.querySelector('[data-qv-opt]:checked');
        opts[pos - 1] = checked ? checked.value : null;
      });
      return opts;
    }
    function match(opts) { return variants.filter(function (v) { return v.options.join('~~') === opts.join('~~'); })[0]; }

    function recomputeAvailability(opts) {
      inputs.forEach(function (inp) {
        var pos = parseInt(inp.getAttribute('data-option-position'), 10) || 1;
        var trial = opts.slice(); trial[pos - 1] = inp.value;
        var v = match(trial);
        inp.setAttribute('data-available', v && v.available ? 'true' : 'false');
      });
    }
    function update() {
      var opts = currentOptions();
      recomputeAvailability(opts);
      var v = match(opts);
      root.querySelectorAll('.qv__opt').forEach(function (fs) {
        var checked = fs.querySelector('[data-qv-opt]:checked');
        var lab = fs.querySelector('[data-qv-opt-value]');
        if (checked && lab) lab.textContent = checked.value;
      });
      if (v) {
        if (vid) vid.value = v.id;
        if (priceEl) priceEl.textContent = v.price_money;
        if (compareEl) { if (v.compare_gt > 0) { compareEl.textContent = v.compare_money; compareEl.hidden = false; } else { compareEl.hidden = true; } }
        if (atcLabel) atcLabel.textContent = v.available ? ATC_LABEL : 'Sold Out';
        if (atc) atc.disabled = !v.available;
        if (v.featured_media_id) selectMedia(v.featured_media_id);
      } else {
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        if (atc) atc.disabled = true;
      }
    }
    inputs.forEach(function (inp) { inp.addEventListener('change', update); });
    if (inputs.length) update();

    // Shop Pay installments
    var terms = root.querySelector('[data-qv-terms]');
    var slot = root.querySelector('[data-qv-installments]');
    if (terms && slot && terms.content) {
      slot.appendChild(terms.content.cloneNode(true));
      if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) {
        try { window.Shopify.PaymentButton.init(); } catch (e) {}
      }
    }

    // Quantity stepper
    var qtyWrap = root.querySelector('[data-qv-qty]');
    if (qtyWrap) {
      var qi = qtyWrap.querySelector('.qv__qty-input');
      var clamp = function (n) { n = parseInt(n, 10); return (isNaN(n) || n < 1) ? 1 : n; };
      qtyWrap.querySelector('[data-qv-qty-minus]').addEventListener('click', function () { qi.value = Math.max(1, clamp(qi.value) - 1); });
      qtyWrap.querySelector('[data-qv-qty-plus]').addEventListener('click', function () { qi.value = clamp(qi.value) + 1; });
      qi.addEventListener('change', function () { qi.value = clamp(qi.value); });
    }

    // Add to Cart → AJAX add, open Minimog drawer, close the modal
    if (form && atc) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atc.disabled || atc.dataset.busy) return;
        atc.dataset.busy = '1'; atc.classList.add('is-busy');
        var S = window.MinimogSettings || {}, T = window.MinimogTheme || {};
        var addUrl = (S.routes && S.routes.cart_add_url) ? S.routes.cart_add_url : '/cart/add';
        fetch(addUrl + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: new FormData(form) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            atc.dataset.busy = ''; atc.classList.remove('is-busy');
            if (res && res.status) { if (T.Notification) T.Notification.show({ target: document.body, method: 'appendChild', type: 'error', message: res.message || res.description, last: 3000, sticky: true }); return; }
            close();
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          })
          .catch(function () { atc.dataset.busy = ''; atc.classList.remove('is-busy'); });
      });
    }
  }

  /* ── Delegated open ── */
  document.addEventListener('click', function (e) {
    // Let the card's own quick-add-to-cart button keep its behaviour.
    if (e.target.closest('[data-pp-rec-cart],[data-pr-cart]')) return;
    var t = e.target.closest('[data-qv-open]');
    if (!t) return;
    var url = t.getAttribute('data-qv-open');
    if (!url) return;
    e.preventDefault();
    open(url);
  });
})();
